import SeeMoreCard from './see-more-card';

export default SeeMoreCard;
